import { createRouter, createWebHashHistory } from 'vue-router'

const LoginPage = () => import(/* webpackChunkName: "route-auth" */ '../components/Login.vue')
const RegisterPage = () => import(/* webpackChunkName: "route-auth" */ '../components/Register.vue')
const ResetPasswordPage = () => import(/* webpackChunkName: "route-auth" */ '../components/ResetPassword.vue')
const CarListPage = () => import(/* webpackChunkName: "route-carlist" */ '../components/CarList.vue')

const routes = [
  {
    path: '/',
    redirect: '/carlist'
  },
  {
    path: '/login',
    name: 'Login',
    component: LoginPage
  },
  {
    path: '/register',
    name: 'Register',
    component: RegisterPage
  },
  {
    path: '/resetpwd',
    name: 'ResetPassword',
    component: ResetPasswordPage
  },
  {
    path: '/carlist',
    name: 'CarList',
    component: CarListPage
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/carlist'
  }
]

const router = createRouter({
  history: createWebHashHistory('/pastel/'),
  routes
})

export default router
